export const visit = (vm, at) => {
at({ "en": { "sanitizedEmail": { "imageError": "This image is too large to display.", "expandEmailButtonText": "Expand", "collapseEmailButtonText": "Collapse", "hideEmailRepliesButtonText": "Hide trimmed content", "showEmailRepliesButtonText": "View trimmed content" } } });
};